import React, { Component } from 'react'
import { Row, Col, Input, Select, Button, Tabs, Table, Pagination, Spin, DatePicker, message} from 'antd'
import common from '@/public/common'
import {ajaxApi, fileDownloadApiNew, getMethod, submitMethod} from '@/server'
import './index.less'
import moment from 'moment'
import { getCookie, getParmUrl } from '../../public/utils'
import reactCSS from 'reactcss'
const { TabPane } = Tabs
const { Option } = Select
const { RangePicker } = DatePicker
class DifferReport extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            search: {
                different: true
            },
            data: [],
            tabType: 'poConfirmed',
            total: 0,
            pageNo: 0,
            pageSize: 20,
            spin: false,
            whid: [],
            data: []
        }
    }
    componentDidMount() {
        this.getWHid()
        this.getDetails()
    }
    // 获取仓库列表
    getWHid = () => {
        getMethod(common.wmsApiUrl+'wms-api/sale-refund-instruct/drop-down-box').then(res => {
           if (res.data.whid) {
               this.setState({
                whid: res.data.whid
               })
           }
       })
    }
    // 获取发货单列表
    getDetails = async() => {
        let param = {
            ...this.state.search,
            status: this.state.tabType,
            page_no: this.state.pageNo,
            page_size: this.state.pageSize,
            sid: getCookie('userName') 
        }
        this.setState({
            spin: true
        })
        const res = await ajaxApi({
            url: common.SapUrl + 'difference/supplier/reports',
            params: param
        })
       
        if (res.data) {
            this.setState({
               spin: false,
               total: res.data.total_count,
               data: res.data.data
            })
        } else {
            this.setState({
                spin: false
            })
        }
    }
    // 获取搜索input内容
    inputChange = (name, e) => {
        let _search = this.state.search
        _search[name] = e.target.value
        this.setState({
            search: _search
        })
    }
    // 获取搜索select内容
    selectChange = (name, val) => {
       let _search = this.state.search
       _search[name] = val
       this.setState({
           search: _search
       })
    }
    // 获取搜索时间内容
    timeChange = (val) => {
      console.log(val)
      let _search = this.state.search
      _search.start_date = new Date(moment(val[0]).format('YYYY-MM-DD')).getTime()
      _search.end_date = new Date(moment(val[0]).format('YYYY-MM-DD')).getTime()
      this.setState({
          search: _search
      })
    }
    // 查询
    search = () => {
        this.getDetails()
    }
    // 重置
    reset = () => {
        this.setState({
            search: {},
            pageNo: 1
        }, () => {
            this.getDetails()
        })
    }
    // 导出
    import = () => {
        fileDownloadApiNew({
            url: common.SapUrl + '/difference/supplier/reports/excel',
            param: {
                sid: getCookie('userName') ,
                ...this.state.search
            },
            filename: '发货单'+moment(new Date()).format('YYYYMMDDHHmmss')+'.xlsx'
        })
    }
    // 确认
    handleOk = async(id) => {
       const res = await ajaxApi({
           url: common.SapUrl + '/difference/report/supplier/confirm',
           params: {
               id: id,
               sid: getCookie('userName') 
           }
       })
       if (res.data === null) {
           message.success('确认成功！')
           this.getDetails()
       }
    }
    tabChange = (val) => {
       if (val === '1') {
           this.setState({
               tabType: 'poConfirmed'
           }, () => {
            this.getDetails()
           })
       } else if (val === '2') {
           this.setState({
               tabType: 'supplierConfirmed'
           }, () => {
            this.getDetails()
           })
       } else {
            this.setState({
                tabType: ''
            }, () => {
                this.getDetails()
            })  
       }
    }
    goDetials = (id) => {
        this.props.history.push('/main/differReport/reportDetails?id='+id)
    }
    print = (id) => {
        this.props.history.push('/main/differReport/reportPrint?id='+id)
    }
    // 分页方法
    pageOnChange = (pageNo, pageSize) => {
       this.setState({
           pageNo: pageNo
       }, () => {
           this.getDetails()
       })
    }
    sizeOnchange = (pageNo, pageSize) => {
        this.setState({
            pageSize: pageSize
        }, () => {
            this.getDetails()
        })
    }
    render() {
        const { total, spin, search, whid, data } = this.state
        const columns = [
            {
                title: '仓库',
                align: 'center',
                dataIndex: 'whid_name'
            },
            {
                title: '单号',
                align: 'center',
                dataIndex: 'difference_code',
                render: (text, record) => (
                    <a onClick={this.goDetials.bind(this, record.id)}>{text}</a>
                )
            },
            {
                title: '发货单',
                align: 'center',
                dataIndex: 'supplier_delivery_code',
            },
            {
                title: '生成时间',
                align: 'center',
                dataIndex: 'gmt_create',
                render: (text) => (
                    <span>{moment(text).format('YYYY-MM-DD HH:mm:ss')}</span>
                )
            },
            {
                title: '报告人',
                align: 'center',
                dataIndex: 'reporter_name'
            },
            {
                title: '操作',
                align: 'center',
               render: (text, record, index) => (
                   <div>
                       <a style={{display: record.status_name === '待供应商确认' ? 'inline-block' : 'none'}} onClick={this.handleOk.bind(this, record.id)}>确认</a>
                       <a style={{marginLeft: '5px'}} onClick={this.print.bind(this, record.id)}>打印</a>
                   </div>
               )
            }
        ]
        return (<div className="differcen">
            <Spin spinning={spin}>
            <div className="search">
                <Row>
                    <Col span={6}>
                        <label>单号：</label>
                        <Input style={{width: '70%'}} value={search.order_number} placeholder="视客采购单、发货单、外部单、退件物流单" onChange={this.inputChange.bind(this, 'order_number')}/>
                    </Col>
                    <Col span={6}>
                        <label>仓库：</label>
                        <Select style={{width: '70%'}} value={search.whid_id} onSelect={this.selectChange.bind(this, 'whid_id')}>
                            {
                                whid.map(item => {
                                    return <Option value={item.key} key={item.key}>{item.value}</Option>
                                })
                            }
                        </Select>
                    </Col>
                    <Col span={8}>
                        <label>生成日期：</label>
                        <RangePicker  style={{width: '70%'}} value={[search.start_date && moment(moment(search.start_date).format('YYYY-MM-DD'), 'YYYY-MM-DD'), search.end_date && moment(moment(search.end_date).format('YYYY-MM-DD'), 'YYYY-MM-DD')]} onChange={this.timeChange}/>
                    </Col>
                </Row>
                <Row style={{marginTop: '15px'}}>
                    <Col span={6}>
                        <label>商品：</label>
                        <Input style={{width: '70%'}} value={search.product} placeholder="商品（货品）、名称（编码）" onChange={this.inputChange.bind(this, 'product')}/>
                    </Col>
                    <Col span={6}>
                        <label>批号：</label>
                        <Input style={{width: '70%'}} value={search.batch_number} onChange={this.inputChange.bind(this, 'batch_number')}/>
                    </Col>
                    <Col span={6}>
                        <label>差异：</label>
                        <Select style={{width: '70%'}} value={search.different} onSelect={this.selectChange.bind(this, 'different')}>
                            <Option value={true}>有</Option>
                            <Option value={false}>无</Option>
                        </Select>
                    </Col>
                    <Col span={6}>
                       <Button type="primary" shape="round" onClick={this.search}>查询</Button>
                       <Button shape="round" style={{marginLeft: '10px'}} onClick={this.reset}>重置</Button>
                       <Button type="primary" shape="round" style={{marginLeft: '10px'}} onClick={this.import}>导出</Button>
                    </Col>
                </Row>
            </div>
            <div className="body">
                <Tabs onChange={this.tabChange}>
                    <TabPane tab="待确认" key="1"></TabPane>
                    <TabPane tab="已确认" key="2"></TabPane>
                    <TabPane tab="全部" key="3"></TabPane>
                </Tabs>
                <Table columns={columns} dataSource={data} pagination={false}/>
                <div className="pagination">
                    <span className="datanum">{'共' + total + '条数据'}</span>
                    <Pagination showQuickJumper showSizeChanger current={(this.state.pageNo) + 1} total={total} pageSize={this.state.pageSize} pageSizeOptions={['15', '20', '30', '50', '100']} onChange={this.pageOnChange} onShowSizeChange={this.sizeOnchange} />
                </div>
            </div>
            </Spin>
        </div>)
    }
}
export default DifferReport


// WEBPACK FOOTER //
// ./src/pages/differReport/index.js